//@flow
import * as entitiesRankingActions from "./EntitiesRankingActions";
import { entitiesRankingReducer } from "./EntitiesRankingReducer";
export { entitiesRankingReducer, entitiesRankingActions };
